<template>
  <section :class="bemBlock">
    <BaseStoreLocatorForm
      :url="url || defaultUrl"
      @store-locator:result="handleResults"
    />
    <div :class="bemElement('container')" v-html="storeLocatorContent" />
  </section>
</template>

<script>
import storeLocator from '../../storeLocator/index';
import { urlWithSearchParams } from '../../common/utils/url';
import bemClassesMixin from '../mixins/bemClassesMixin';
import windowResizeMixin from '../mixins/windowResizeMixin';
import BaseStoreLocatorForm from './BaseStoreLocatorForm.vue';
import getAnalyticsEventBus from '../../common/getAnalyticsEventBus';
import getFrontConfig from '../../common/getFrontConfig';

const analyticsEventBus = getAnalyticsEventBus();

const {
  responsive: { bp_1025: bp1025 },
  urls: { findStores },
} = getFrontConfig();

export default {
  name: 'BaseStoreLocator',

  components: {
    BaseStoreLocatorForm,
  },

  mixins: [bemClassesMixin, windowResizeMixin],

  props: {
    url: {
      type: String,
      default: null,
      required: false,
    },
  },

  data() {
    return {
      dataChangeBreakpoint: bp1025,
      storeLocatorContent: '',
      atcPhoneListener: (evt) => {
        if (evt.target.matches('.store-phone__call')) {
          analyticsEventBus.publish(
            analyticsEventBus.EVENTS.atcPhoneClicked,
            analyticsEventBus.EVENTS.PAYLOADS.atcPhoneClicked.location
              .storeAvailability
          );
        }
      },
    };
  },

  computed: {
    defaultUrl() {
      return urlWithSearchParams(findStores, {
        filterByDroppoint: false,
        visibleInStoreFinder: true,
      });
    },
  },

  watch: {
    storeLocatorContent() {
      this.$nextTick(() => {
        storeLocator.init();
        // Click on shop phone number when in store stock modal is open analytics event
        const inStoreStockModalContent = document.querySelectorAll(
          '.the-in-store-stock-modal__main-content'
        );
        Array.from(inStoreStockModalContent).forEach((element) => {
          element.removeEventListener('click', this.atcPhoneListener);
          element.addEventListener('click', this.atcPhoneListener);
        });
      });
    },
  },

  mounted() {
    this.$nextTick(() => {
      storeLocator.init();
    });
  },

  methods: {
    handleResults(data) {
      window.initMap = () => {
        this.storeLocatorContent = data.storesResultsHtml;
      };
      this.loadScript(`${data.googleMapsApi}&callback=initMap`, window.initMap);
    },
    loadScript(scriptSrc, callback) {
      const existingScript = document.querySelector(
        `script[src="${scriptSrc}"]`
      );
      if (!existingScript && scriptSrc) {
        const script = document.createElement('script');
        script.setAttribute('async', '');
        script.setAttribute('src', scriptSrc);
        document.head.appendChild(script);
      } else {
        callback();
      }
    },
  },
};
</script>
